import { withStyles } from '@material-ui/core/styles';
import React, { useState, useEffect } from 'react';
import * as v from '../../../helpers/validation';
import { Paper } from '@material-ui/core';
import classnames from 'classnames';
// SERVICES
import { postApiUser } from '../../../services/apiUser.service';
import { getClientList } from '../../../services/client.service';
import { DynamicForm } from '../../DynamicForm';

const styles = props => ({ paper: { padding: '24px', boxSizing: 'border-box' } });

export const APIUserCreate = withStyles(styles)(({ classes }) => {
  const [clientList, setClientList] = useState([]);

  useEffect(() => {
    getClientListAsync();
  }, []);

  const getClientListAsync = async () => {
    let clients = await getClientList();
    clients = clients.map(c => ({
      value: c.id,
      label: `${c.name} ${c.code && `(${c.code})`}`,
    }));
    setClientList(clients);
  };

  const clientOptions = clientList;

  const handleSave = async (formData) => {
    // Validate password strength if provided
    const hasPassword = formData.password && formData.password.trim().length > 0;
    if (hasPassword) {
      const passwordError = v.password()(formData.password);
      if (passwordError) {
        throw new Error(passwordError);
      }
    }

    // Call the API service
    return await postApiUser(formData);
  };

  // Selected Clients preview removed per request

  const apiUserInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'text',
              field: 'email',
              label: 'E-mail',
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'userName',
              label: 'Username',
              validate: [v.required()],
            },
            {
              inputType: 'password',
              field: 'password',
              label: 'Password',
              placeholder: 'Enter password (min 6 chars, 1 uppercase, 1 digit, 1 special char)',
              validate: [v.required(), v.password()],
            },
            {
              inputType: 'select',
              field: 'accountStatusId',
              label: 'Account Status',
              options: [
                { value: '1', label: 'Active' },
                { value: '2', label: 'Inactive' },
              ],
              validate: [v.checkAccountStatus('Record Type must be `Active` or `Inactive`')],
            },
            {
                inputType: 'text',
                field: 'notes',
                label: 'Notes',
                validate: [],
            }
          ],
        },
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'select',
              field: 'apiuserClients',
              label: 'Clients',
              options: clientOptions,
              isMulti: true,
            },
            // selected clients preview removed
          ],
        },
      ],
    },
  ];

  return (
    <Paper className={classnames(classes.paper, 'border-left-green')} elevation={1}>
      <DynamicForm
        inputs={apiUserInputs}
        mode={'CREATE'}
        onSave={handleSave}
        redirectOnSuccess={'/users/api-users'}
      />
    </Paper>
  );
}); 